// extracted by mini-css-extract-plugin
module.exports = {"container":"IndexFulfillmentModal_container__2xGRp","indexName":"IndexFulfillmentModal_indexName__2QHF-","colBackground":"IndexFulfillmentModal_colBackground__3WDBy"};